// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"64f90ebf","129":"f673bc97","175":"32f1612f","523":"b4dbbbf3","546":"0dbfe3fa","910":"488906f2"}[chunkId] + ".chunk.js";
};